// eslint-disable-next-line no-underscore-dangle
const env = window._env_ || {};

const CONFIG = {
  API_URL: env.REACT_APP_API_URL,
  CURRENT_PAYS: env.REACT_APP_CURRENT_PAYS,
  PHONE_NUMBER_LENGTH: Number(env.REACT_APP_PHONE_NUMBER_LENGTH),
  CODE_CLIENT: env.REACT_APP_CODE_CLIENT,
  DECOUPAGE_ADMINISTRATIF: (env.REACT_APP_DECOUPAGE_ADMINISTRATIF || "")?.split(","),
  CATEGORIE_ESPECE: (env.REACT_APP_CATEGORIE_ESPECE || "")?.split(","),
  IS_MODULE_REPRODUCTION: env.REACT_APP_IS_MODULE_REPRODUCTION,
  IS_MODULE_SANTE_ANIMAL: env.REACT_APP_IS_MODULE_SANTE_ANIMAL,
  API_URL_TRACCAR: env.REACT_APP_API_URL_TRACCAR,
  TRACCAR_EMAIL: env.REACT_APP_TRACCAR_EMAIL,
  TRACCAR_PSW: env.REACT_APP_TRACCAR_PSW,
  SECRET_KEY: env.REACT_APP_SECRET_KEY,
  // DEFAULT_ENTITE: (env.REACT_APP_DEFAULT_ENTITE || "").split(","),
  // REACT_APP_DEFAULT_ENTITE: env.REACT_APP_DEFAULT_ENTITE,
};

export default CONFIG;
